export enum Role {
  GUEST = 'GUEST',
  AGENT = 'AGENT',
  ADMIN = 'ADMIN', // Access to Everything
  CONTENT_ADMIN = 'CONTENT_ADMIN',
  REPORTS_ADMIN = 'REPORTS_ADMIN',
  TEAM_LEAD = 'TEAM_LEAD'
}
